/**
 * Single source of truth for the language the app boots with.
 * Used by the APP_INITIALIZER in AppModule and by AppComponent.
 */
export function getActiveLang(): string {
   return localStorage.getItem('lang') || 'en';
}
